import { fetchAirtableRecord } from "../airtable/FetchAirtableRecord";
import { AirtableRecordResponse, AirtableTableId } from "../airtable/types";
import { fetchRailData } from "../FetchRailData";
import { PageData } from "./types";

/**
 * Given a AirtableRecordResponse for a Page from Airtable,
 * returns an PageData populated with `page` and rails with ATOM data
 * If "Collections" is not a valid field (i.e. not a Page response), returns empty rails array
 *
 * @param page - AirtableRecordResponse for a Page in Airtable
 * @returns Promise that resolves to a PageData with `page` and RailData with ATOM data or an empty PageData
 */
const fetchPageData = async (
  page: AirtableRecordResponse,
): Promise<PageData> => {
  if ("Collections" in page.fields && page.fields.Collections !== undefined) {
    const railIds = page.fields.Collections;

    const rails = await Promise.all(
      railIds.map((id) =>
        fetchAirtableRecord(`${AirtableTableId.Collections}/${id}`),
      ),
    );

    const assets = await Promise.all(rails.map(fetchRailData));

    return { self: page, rails: assets };
  } else {
    return { self: page, rails: [] };
  }
};

export { fetchPageData };
